import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/Tabs';
import Icon from '@/components/AppIcon';
import { PageLayout } from '@/components/ui/PageLayout';
import { Settings2 } from 'lucide-react';
import MovementTypesTab from './components/MovementTypesTab';
import ExitReasonsTab from './components/ExitReasonsTab';
import OnboardingTaskTypesTab from './components/OnboardingTaskTypesTab';
import OffboardingTaskTypesTab from './components/OffboardingTaskTypesTab';
import MovementTaskTypesTab from './components/MovementTaskTypesTab';

const LifecycleSettings: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>('movement-types');

  return (
    <PageLayout
      title={t('Lifecycle Settings')}
      description={t('Configure categories and types used across the employment lifecycle')}
      icon={Settings2}
      accentColor="amber"
    >
      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="mb-6">
          <TabsTrigger value="movement-types" className="flex items-center gap-2">
            <Icon name="ArrowRightLeft" size={16} />
            {t('Movement Types')}
          </TabsTrigger>
          <TabsTrigger value="exit-reasons" className="flex items-center gap-2">
            <Icon name="UserMinus" size={16} />
            {t('Exit Reasons')}
          </TabsTrigger>
          <TabsTrigger value="onboarding-task-types" className="flex items-center gap-2">
            <Icon name="UserPlus" size={16} />
            {t('Onboarding Tasks')}
          </TabsTrigger>
          <TabsTrigger value="offboarding-task-types" className="flex items-center gap-2">
            <Icon name="UserX" size={16} />
            {t('Offboarding Tasks')}
          </TabsTrigger>
          <TabsTrigger value="movement-task-types" className="flex items-center gap-2">
            <Icon name="ArrowRightLeft" size={16} />
            {t('Movement Tasks')}
          </TabsTrigger>
        </TabsList>

        <TabsContent value="movement-types">
          <MovementTypesTab />
        </TabsContent>
        <TabsContent value="exit-reasons">
          <ExitReasonsTab />
        </TabsContent>
        <TabsContent value="onboarding-task-types">
          <OnboardingTaskTypesTab />
        </TabsContent>
        <TabsContent value="offboarding-task-types">
          <OffboardingTaskTypesTab />
        </TabsContent>
        <TabsContent value="movement-task-types">
          <MovementTaskTypesTab />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
};

export default LifecycleSettings;
